import styles from './Hero.module.scss'
import { Heading, Img } from '@boltenergy-be/design-system'
import { HeroProps } from './types'

const Hero = ({ category, subCategory }: HeroProps) => {
  // Constants
  const title: string = subCategory ?? category.attributes.title

  return (
    <section className="container">
      <div className={styles.hero} style={{ backgroundColor: category.attributes.color }}>
        <div className={styles['title-wrapper']}>
          <Heading as="h1" variant="h2" className={styles.title}>
            {title}
          </Heading>
          {subCategory && (
            <>
              <br />
              <strong>{category.attributes.title}</strong>
            </>
          )}
        </div>
        {category.attributes.icon && (
          <figure className={styles['img-wrapper']}>
            <Img
              publicId={category.attributes.icon.data?.attributes?.provider_metadata?.public_id}
              alt={category.attributes.title}
              fill
              sizes="(max-width: 620px) 75vw, (max-width: 920px) 50vw, 33vw"
            />
          </figure>
        )}
      </div>
    </section>
  )
}

export default Hero
